import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
import { GenericErrorBoundary } from '../components/2compounds/GenericErrorBoundary'
import AddClientImportLocationForm from '../pages/smartForm/addClient/ImportLocationForm'
import AddClientImportPeopleForm from '../pages/smartForm/addClient/ImportPeopleForm'
import AddClientImportServiceForm from '../pages/smartForm/addClient/ImportServiceForm'
import AddClientImportServiceSet from '../pages/smartForm/addClient/ImportServiceSet'
import AddLocationImportLocationForm from '../pages/smartForm/addLocation/ImportLocationForm'
import AddLocationImportPeopleForm from '../pages/smartForm/addLocation/ImportPeopleForm'
import AddLocationImportServiceForm from '../pages/smartForm/addLocation/ImportServiceForm'
import AddPeopleImportPeopleForm from '../pages/smartForm/addPeople/ImportPeopleForm'
import AddServiceImportNewServiceForm from '../pages/smartForm/addService/ImportNewServiceForm'
import AddServiceImportServiceForm from '../pages/smartForm/addService/ImportServiceForm'

const routesByFlow = {
  addClient: [
    { path: 'servicesImport', Component: AddClientImportServiceSet },
    { path: 'location', Component: AddClientImportLocationForm },
    { path: 'people', Component: AddClientImportPeopleForm },
    { path: 'service', Component: AddClientImportServiceForm },
  ],
  addLocation: [
    { path: 'location', Component: AddLocationImportLocationForm },
    { path: 'people', Component: AddLocationImportPeopleForm },
    { path: 'service', Component: AddLocationImportServiceForm },
  ],
  addPeople: [
    { path: 'people', Component: AddPeopleImportPeopleForm },
  ],
  addService: [
    { path: 'service', Component: AddServiceImportServiceForm },
    { path: 'newService', Component: AddServiceImportNewServiceForm },
  ],
}

const AddWorkflowRoutes = ({ flow }) => (
  <Routes>
    {routesByFlow[flow].map(({ path, Component }) => (
      <Route
        key={path}
        path={path}
        element={(
          <GenericErrorBoundary>
            <Component />
          </GenericErrorBoundary>
        )}
      />
    ))}
  </Routes>
)

AddWorkflowRoutes.propTypes = {
  flow: PropTypes.oneOf(Object.keys(routesByFlow)).isRequired,
}

export default AddWorkflowRoutes
